/**
 * ThemeToggle Atom
 * @layer atom
 * @package @plerity/dashboard-shared
 */
import { Monitor, Moon, Sun } from "lucide-react";
import { useThemeStore } from "../../stores/themeStore";

const MODES = ["light", "dark", "system"] as const;

const MODE_ICON = {
  light: Sun,
  dark: Moon,
  system: Monitor,
} as const;

const MODE_LABEL = {
  light: "Light mode",
  dark: "Dark mode",
  system: "System theme",
} as const;

export function ThemeToggle() {
  const theme = useThemeStore((s) => s.theme);
  const setTheme = useThemeStore((s) => s.setTheme);

  const cycle = () => {
    const idx = MODES.indexOf(theme);
    const next = MODES[(idx + 1) % MODES.length];
    setTheme(next);
  };

  const Icon = MODE_ICON[theme];

  return (
    <button
      type="button"
      onClick={cycle}
      className="rounded-md p-2 text-muted hover:bg-surface-subtle hover:text-gray-700 dark:hover:text-gray-200"
      aria-label={MODE_LABEL[theme]}
      title={MODE_LABEL[theme]}
    >
      <Icon className="h-5 w-5" aria-hidden="true" />
    </button>
  );
}
